import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCheckmarkRoundedFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m7.74 12-8.3 8.3L14 21.72l-1.46-1.42L8.26 16a.99.99 0 0 1 0-1.42c.4-.4 1.04-.4 1.44 0l4.3 4.26 8.3-8.26c.4-.4 1.06-.4 1.46 0s.38 1.04-.02 1.42" clipRule="evenodd" /></svg>;
export default SvgIconCheckmarkRoundedFilled;